import React, {useEffect, useState} from "react";
import {RecipeDataHandler} from "../../logic/db/RecipeDataHandler";
import {useLocation} from "react-router";
import {defaultRecipe} from "../../global/defaults";
import ControlledForm from "../../reusable/ControlledForm/ControlledForm";
import TextInput from "../../reusable/ControlledForm/Inputs/TextInput";
import UnitInput from "../../reusable/ControlledForm/Inputs/UnitInput";
import DefaultSubmissionZone from "../../reusable/ControlledForm/Submissions/DefaultSubmissionZone";
import {lengthUnits, massUnits} from "../../global/lists";
import {useNavigate} from "react-router-dom"
import RecipeFormIngredients from "./RecipeFormIngredients";
import {RecipeModel} from "../../logic/models/RecipeModel";
import {useTranslation} from "react-i18next";

type RecipeFormProps = {
    mode: "edit" | "add",
}

export const RecipeForm = (props: RecipeFormProps) => {
    const {mode} = props
    const [recipeModel, setRecipeModel] = useState<RecipeModel>(new RecipeModel({recipe: defaultRecipe}))
    const [fetchingData, setFetchingData] = useState<boolean>(props.mode === "edit")
    const navigate = useNavigate()
    const {t} = useTranslation("common")

    const locations = useLocation().pathname.split('/')

    useEffect(() => {
        if (props.mode === "edit") {
            RecipeDataHandler.getRecipeByName(locations[locations.length - 1]).then((recipe) => {
                setRecipeModel(new RecipeModel({recipe}))
                setFetchingData(false)
            }).catch(() => "FAILURE!")
        }
    }, [])

    const onSubmit = (event: any, submission: any) => {
        event.preventDefault()
        const recipeSubmission = new RecipeModel({formData: submission})
        const dataBaseAction = props.mode === "add" ? RecipeDataHandler.addRecipe : RecipeDataHandler.updateRecipe
        dataBaseAction(recipeSubmission.recipe, recipeModel.hasSameName(submission) ? undefined : recipeModel.recipe.name)
            .then(() => navigate(-1))
            .catch(() => console.log("FAILURE!"))
    }

    const lengthOptions = lengthUnits.map(unit => { return {value: unit, name: t(`units.length.${unit}`)}})
    const massOptions = massUnits.map(unit => { return {value: unit, name: t((`units.mass.${unit}`))}})

    return ( !fetchingData ?
        <div className="recipe-form-wrapper">
            <ControlledForm initialValues={recipeModel.toFormData()} onSubmit={onSubmit}>
                <h3 className="modal-title">{t(mode === "add" ? "add.add_recipe" : "edit.edit_recipe")}</h3>
                <TextInput name={"name"} label={t("data.name")}/>
                <TextInput name={"description"} label={t("data.description")} multiLine={true}/>
                <UnitInput numberName={"mass"} label={t("units.mass.mass")} unitName={"massUnit"} options={massOptions}/>
                <UnitInput numberName={"diameter"} label={t("units.length.diameter")} unitName={"diameterUnit"} options={lengthOptions}/>
                <UnitInput numberName={"height"} label={t("units.length.height")} unitName={"heightUnit"} options={lengthOptions}/>
                <RecipeFormIngredients/>
                <DefaultSubmissionZone submitText={t(mode === "add" ? "add.add" : "edit.edit")} cancelText={t("cancel")} onCancel={() => navigate(-1)}/>
            </ControlledForm>
        </div> : null
    )
}
